var handlerBlocks = {
  globalCarouselArrow: { 
    x0: 15,
    x1: 60, y1: 40,
    x2: 65, y2: 35,
    x3: 25
  },
  init: function() {
    var self = this;
    // show background image on More About Us item hover
    if ($html.is('.no-touchevents')) {
      $('.mau-item')
      .on("mouseenter", function(e) {
        var $bgs = $(this).parents('.block-more-about-us').find('.hover-image');
        var $targetBg = $bgs.filter('[data-key="'+$(this).data('bg-target')+'"]');
        $bgs.removeClass('hovered');
        $targetBg.addClass('hovered');
      })
      .on('mouseleave', function() {
        var $bgs = $(this).parents('.block-more-about-us').find('.hover-image');
        $bgs.removeClass('hovered');
      });
    }
    // numerize numbered headings
    var counter = 1;
    $('.block-numbered-heading .number-container').each(function() {
      $(this).html(String(counter).padStart(2, '0'));
      counter++;
    });
    // carousel for tiled images
    $('.block-tiled-images .carousel').each(function() {
      $(this).flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        pageDots: true,
        fade: false,
        wrapAround: false,
        freeScroll: false,
        prevNextButtons: true,
        draggable: true,
        arrowShape: self.globalCarouselArrow
      });
    });
    // adjust testimonies carousel's arrows position according to photo height
    $window.on("resize", function() {
      if (Foundation.MediaQuery.only('small')) {
        var photoHeight = $('.block-testimonies .carousel .testimony-container .rounded-image').eq(0).outerHeight();
        $('.block-testimonies .carousel').css('--carousel-arrows-small-top', photoHeight+'px');
      }
    });
    // carousel for testimonies
    $('.block-testimonies .carousel').each(function() {
      $(this).flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        pageDots: true,
        fade: false,
        wrapAround: false,
        freeScroll: false,
        prevNextButtons: true,
        draggable: false,
        arrowShape: self.globalCarouselArrow
      });
    });
    // adjust image for testimonial popup
    $('.reveal.testimony-reveal').on('open.zf.reveal', function() {
      var $current = $(this);
      setTimeout(function() {
        var $image = $current.find('.rounded-image');
        $image.height($image.width());
      },250);
    });
    // carousel for product slider
    $('.block-product-slider .carousel').each(function() {
      $(this).flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        pageDots: false,
        fade: false,
        wrapAround: false,
        freeScroll: false,
        prevNextButtons: true,
        draggable: true,
        arrowShape: self.globalCarouselArrow
      });
    });
    // autoselect first mechanism on product detail
    $('.block-product-details').each(function() {
      $(this).find('.carousel').flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        pageDots: false,
        fade: true,
        wrapAround: false,
        freeScroll: false,
        prevNextButtons: false,
        draggable: false
      });
    });
    handlerNavigation.selectNavOption($('.block-product-details .mechanism .select-option').eq(0));
    handlerNavigation.selectNavOption($('.block-product-details .formulation .select-option').eq(0));
  },
};